import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import AccArrowDown from '../../../../images/contract-admin-icons/AccArrowDown';
import AccArrowUp from '../../../../images/contract-admin-icons/AccArrowUp';

const MidAccordionFirstChild = ({
  data = {},
  isAnyCheckBoxChecked,
  updateChildProdDeliverable,
  prodData,
  setIsModalMessageOpen,
}) => {
  const [active, setActive] = useState(false);
  const handleToggle = () => {
    setActive(!active);
  };
  const isRldSelected = prodData.some(
    item => item.optionId === 8 && item.selected
  );
  const rldCustomFiles = prodData
    .flatMap(item => item.optionId === 4 && item.modules)
    .map(data => data && data.optionId);
  const setChecked = () => {
    if (!isRldSelected) {
      data.selected = !data.selected;
      isAnyCheckBoxChecked(data);
    } else {
      if (rldCustomFiles.includes(data.optionId)) {
        data.selected = !data.selected;
        isAnyCheckBoxChecked(data);
      } else {
        data.selected = false;
        isAnyCheckBoxChecked(data);
        setIsModalMessageOpen(true);
      }
    }
  };

  return (
    <Fragment>
      <div className="ent-acc-child">
        <button
          type="button"
          key={Math.random()}
          className={
            data.modules && data.modules.length
              ? 'ent-acc-toggle'
              : 'ent-acc-toggle display-hide'
          }
          onClick={() => handleToggle()}
        >
          {active ? <AccArrowUp /> : <AccArrowDown />}
        </button>
        <div
          className={
            data.isAnyChildSelected
              ? 'ent-acc-mid-module isAnyItemSelected'
              : 'ent-acc-mid-module'
          }
        >
          <input
            id={data.optionName}
            type="checkbox"
            key={Math.random()}
            onChange={() => setChecked()}
            value={data.selected}
            defaultChecked={data.selected}
          />
          <label htmlFor={data.optionName} title={data.optionName}>
            {data.optionName}
          </label>
        </div>
      </div>
      {active &&
        data.modules &&
        data.modules.map(item => (
          <div className="ent-acc-mid-last-child" data-test="LastChild">
            <input
              id={item.optionName}
              type="checkbox"
              key={Math.random()}
              value={item.selected}
              onChange={() => {
                item.selected = !item.selected;
                updateChildProdDeliverable(data, item);
              }}
              defaultChecked={item.selected}
            />
            <label htmlFor={item.optionName} title={item.optionName}>
              {item.optionName}
            </label>
          </div>
        ))}
    </Fragment>
  );
};
MidAccordionFirstChild.propTypes = {
  data: PropTypes.shape({}),
  isAnyCheckBoxChecked: PropTypes.func,
  updateChildProdDeliverable: PropTypes.func,
  prodData: PropTypes.array,
  setIsModalMessageOpen: PropTypes.func,
};

export default React.memo(MidAccordionFirstChild);
